module.exports = __webpack_public_path__ + "img/logo1.dcf1bd77.png";